import React from 'react';
import ReactDOM from 'react-dom'; import App from './screens/App';
// Global app font: Geist Sans (self-hosted, offline-safe)
import '@fontsource/geist-sans/400.css';
import '@fontsource/geist-sans/500.css';
import '@fontsource/geist-sans/600.css';
import '@fontsource/geist-sans/700.css';
import * as serviceWorker from './serviceWorker';
import './helpers/sessionGuard';

ReactDOM.render(
  <App />,
  document.getElementById('root'),
);

serviceWorker.unregister();
